import { render, staticRenderFns } from "./ConfigurationIntegrationRouterView.vue?vue&type=template&id=c40cba2e&scoped=true&"
import script from "./ConfigurationIntegrationRouterView.vue?vue&type=script&lang=js&"
export * from "./ConfigurationIntegrationRouterView.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationIntegrationRouterView.vue?vue&type=style&index=0&id=c40cba2e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40cba2e",
  null
  
)

export default component.exports